/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_H_ResearchInputs */

const en_funnel_ob_demo_h_research = /** @type {(inputs: Funnel_Ob_Demo_H_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hear a real paper, with the footnotes skipped.`)
};

const es_funnel_ob_demo_h_research = /** @type {(inputs: Funnel_Ob_Demo_H_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha un artículo real, con las notas al pie omitidas.`)
};

/**
* | output |
* | --- |
* | "Hear a real paper, with the footnotes skipped." |
*
* @param {Funnel_Ob_Demo_H_ResearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_h_research = /** @type {((inputs?: Funnel_Ob_Demo_H_ResearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_H_ResearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_h_research(inputs)
	return en_funnel_ob_demo_h_research(inputs)
});